import type * as Types from 'app/types/graphql';

import { ShopPlatformPlanCreateSelectFragmentDoc } from '../fragments/shopPlatformPlan.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopPlatformPlanCreateMutationVariables = Types.Exact<{
  input: Types.CreateShopPlatformPlanInput;
}>;

export type ShopPlatformPlanCreateMutationResponse = {
  shopPlatformPlanCreate?: Types.Maybe<Pick<Types.ShopPlatformPlan, 'confirmationURL'>>;
};

export const ShopPlatformPlanCreateDocument = `
    mutation ShopPlatformPlanCreate($input: CreateShopPlatformPlanInput!) {
  shopPlatformPlanCreate(input: $input) {
    ...ShopPlatformPlanCreateSelect
  }
}
    ${ShopPlatformPlanCreateSelectFragmentDoc}`;

export const useShopPlatformPlanCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ShopPlatformPlanCreateMutationResponse,
    TError,
    ShopPlatformPlanCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ShopPlatformPlanCreateMutationResponse,
    TError,
    ShopPlatformPlanCreateMutationVariables,
    TContext
  >(
    ['ShopPlatformPlanCreate'],
    (variables?: ShopPlatformPlanCreateMutationVariables) =>
      appFetcher<ShopPlatformPlanCreateMutationResponse, ShopPlatformPlanCreateMutationVariables>(
        ShopPlatformPlanCreateDocument,
        variables,
      )(),
    options,
  );
};

useShopPlatformPlanCreateMutation.getKey = () => ['ShopPlatformPlanCreate'];
